module.exports = __webpack_public_path__ + "img/ic_water.b95b39c8.png";